import { render, staticRenderFns } from "./cis-account.vue?vue&type=template&id=27a70eb7"
import script from "./cis-account.vue?vue&type=script&lang=js"
export * from "./cis-account.vue?vue&type=script&lang=js"
import style0 from "./cis-account.vue?vue&type=style&index=0&id=27a70eb7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports